import { ALTO_COLORS } from '../alto';

export const ALERT_COLORS = {
  SUCCESS: '#F0F9F4', // ALTO_COLORS.PALETTE.SUCCESS.LIGHTEST removed from palette
  ERROR: ALTO_COLORS.PALETTE.DANGER.LIGHTEST,
  NEUTRAL: ALTO_COLORS.PALETTE.PRIMARY.LIGHTER,
  WARNING: '#FFFAE9', // ALTO_COLORS.PALETTE.WARNING.LIGHTEST removed from palette
} as const;
